import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { Loader } from '@app/core';
import { useCurrentParticipant } from '@app/api';
import { useNavigate } from 'react-router-dom';
import { VerifyEmailViaCodeModal } from '@app/auth';

const useStyles = createUseStyles((theme: Theme) => ({
  page: {
    width: '100%',
    background: theme.colors.grayBackground,
    minHeight: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export const VerifyEmailSignUp = () => {
  const classes = useStyles();
  const { data: participant, isLoading } = useCurrentParticipant();
  const navigate = useNavigate();

  const continueSignUp = () => {
    navigate('/registration/preferences');
  };

  if (isLoading) {
    return (
      <div className={classes.page}>
        <Loader />
      </div>
    );
  }
  if (!participant || participant.emailValidated) {
    navigate('/registration/preferences');
  }

  return (
    <div className={classes.page}>
      <VerifyEmailViaCodeModal
        onRequestClose={continueSignUp}
        isOpen={true}
        email={participant?.email}
        onSuccess={continueSignUp}
      />
    </div>
  );
};
